const LocalStorageService = {
	set: function (key: string, value: any) {
		if (value === undefined || value === null) {
			localStorage.removeItem(key)
			return
		}
		localStorage.setItem(key, JSON.stringify(value))
	},

	get: function (key: string): any {
		const value = localStorage.getItem(key)

		if (!value || value === "undefined") return null

		try {
			return JSON.parse(value)
		} catch {
			return null
		}
	},

	remove: function (key: string): void {
		localStorage.removeItem(key)
	}
}

export default LocalStorageService
